<template>
  <div :style="optionalShowStyle">
    <!-- 信息展示start -->
    <div :class="getCss('lottery-optional-info')" :style="lotteryOptionalInfo">
      <div :class="getCss('lottery-info-text-exhibition')">
        <p :class="getCss('lottery-optional-text-button')">
          <span :style="routineFontStyle">{{ lotteryCzText }}：{{ lotteryCzNum }}</span></p>
      <!--  <p :class="getCss('lottery-optional-numerical-text')" :style="routineFontStyle"></p> -->
        <p :class="getCss('lottery-optional-text-button')">
          <span :style="routineFontStyle">{{ lotteryNumText }}：{{ lotteryNum }}</span>
         <!-- <span :class="getCss('lottery-optional-numerical-text')" :style="routineFontStyle"></span>--></p>
       <!-- <p><span :class="getCss('lottery-optional-story-text')"
                 @click="handleClaimRecord" :style="historyFontStyle">{{ storyText }}</span></p>-->
        <p :class="getCss('lottery-optional-button')" :style="lotteryOptionalButton"
        @click="showLanternOptionalPop"></p>
      </div>
      <ul :class="getCss('lottery-optional-rare-exhibition')">
        <li :class="getCss('lottery-optional-rare-li')" v-for="(item,key) in optionalRareList" :key="key"
        v-show="parseInt(item.first, 10) === 0">
          <div :class="getCss('lottery-optional-rare-img')" :style="lotteryOptionalRareBackground">
            <p :class="getCss('lottery-optional-rare-allowance-num')" :style="allowanceFontStyle">余:{{item.iLeft}}</p>
            <img :src="item.img">
          </div>
         <!-- <div :class="getCss('lottery-optional-rare-allowance')" :style="lotteryOptionalRareAllowanceBackground">
            <span :style="routineFontStyle">余量
              <p :class="getCss('lottery-optional-rare-allowance-num')">{{item.iLeft}}</p></span>
          </div>-->
          <p :class="getCss('lottery-optional-rare-allowance-text')" :style="routineFontStyle">
            {{ item.name }}
          </p>
        </li>
      </ul>
    </div>
    <!-- 信息展示end -->
    <p :class="getCss('lottery-optional-story-text-p')"><span :class="getCss('lottery-optional-story-text')"
                 @click="handleClaimRecord" :style="historyFontStyle">{{ storyText }}</span></p>
    <!-- 灯笼展示start -->
    <div :class="getCss('lottery-show-lantern-body')">
      <div :class="getCss('lottery-show-lantern-content')" :style="lotteryLanternUlBackground">
        <div :class="getCss('lottery-lantern-top-line')">
          <div :class="getCss('lottery-lantern')"
               v-for="key of 5"
               :key="key"
          >
            <img :src="key <= drawNum ? lotteryLanternDrawBlack : lotteryLanternBlack">
          </div>
        </div>
        <div :class="getCss('lottery-lantern-center-line')">
          <div :class="getCss('lottery-lantern')"
               v-for="key of 4"
               :key="key"
          >
            <img :src="(key + 5)  <= drawNum ?
               lotteryLanternDrawBlack : lotteryLanternBlack">
          </div>
        </div>
        <div :class="getCss('lottery-lantern-bottom-line')">
          <div :class="getCss('lottery-lantern')"
               v-for="key of 5"
               :key="key"
          >
            <img :src="(key + 9) <= drawNum ?
               lotteryLanternDrawBlack : lotteryLanternBlack">
          </div>
        </div>
        <div :class="getCss('lottery-lantern-footer-line')">
          <div :class="getCss('lottery-lantern')"
               v-for="key of 6"
               :key="key"
          >
            <img :src="(key + 14) <= drawNum ?
               lotteryLanternDrawBlack : lotteryLanternBlack">
          </div>
        </div>
      </div>
      <p :class="getCss('lottery-lantern-button')" :style="lotteryLanternButton"
      @click="doLottery"></p>
    </div>
    <!-- 灯笼展示end -->
    <!-- 轮播start -->
    <div  :class="getCss('lottery-lantern-carousel')" :style="lotteryLanternCarousel">
      <div :class="getCss('lottery-lantern-carousel-box')">
        <ul :class="getCss('lottery-lantern-carousel-ul')"
            :style="`animation-duration: ${carouselList.length * 2}s;`">
          <li  v-for="(item,key) in carouselList" :key="key"
               :class="getCss('lottery-lantern-carousel-text')"
          :style="carouselFontStyle">
            <span>{{ carouselLeftText }} </span>
            {{ item.uid }}
            <span>获得 </span>
            {{item.packageName}}
          </li>
          <li  v-for="(item,key) in carouselList" :key="key + 'copy'"
               :class="getCss('lottery-lantern-carousel-text')"
          :style="carouselFontStyle">
            <span>{{ carouselLeftText }} </span>
            {{ item.uid }}
            <span>获得 </span>
            {{item.packageName}}
          </li>
        </ul>
      </div>
    </div>
    <!-- 轮播end -->
    <!-- 自选start -->
    <div :class="getCss('lottery-lantern-optional-tc')" v-show="isShowOptionalPop">
      <div :class="getCss('lottery-lantern-optional-zz')">
      </div>
      <div :class="getCss('lottery-lantern-optional-content')" :style="lotteryLanternOptionalContent">
        <p :class="getCss('lottery-lantern-optional-close')" :style="lotteryLanternOptionalClose"
           @click="closeLanternOptionalPop"></p>
        <ul :class="getCss('lottery-lantern-optional-select-ul')">
          <li v-for="(item,key) in this.configurationData.selectUl" :key="key"
              :class="getCss(selectId === key ?
              'lottery-lantern-optional-select-li1' : 'lottery-lantern-optional-select-li')"
              :style="selectId === key ? lotteryLanternOptionalSelectLi1 : lotteryLanternOptionalSelectLi"
          @click="selectClick(key)">
            <p></p>
          </li>
        </ul>
        <div :class="getCss('select-text-div')" :style="selectRuleFontStyle">{{ selectRuleText }}</div>
        <ul :class="getCss('lottery-lantern-optional-select-option')">
          <li :class="getCss('lottery-lantern-optional-select-option-li')"
              v-for="(item,key) in optionalRareList" :key="key" v-show="parseInt(item.first, 10) === selectId"
          >
            <div :class="getCss('lottery-lantern-optional-select-option-gift-img')">
              <img :src="item.img" width="56" alt="">
            </div>
            <div :class="getCss('checkbox_input_div')">
              <input
                type="checkbox" :value="item.giftId" :checked="item.checked"
                @change="getCheckedInfo(item.giftId , item.checked)"
                :id="`selectOptionGiftCheckbox${item.giftId}`"
                readonly="readonly"
                :class="getCss('checkbox_input')">
            </div>
            <label :for="`selectOptionGiftCheckbox${item.giftId}`"
                   :class="getCss('lottery-lantern-optional-select-option-gift-label')">
              <img :src="item.checked ? selectOptionGiftChecked : selectOptionGiftCheckbox">
            </label>
            <p :style="routineFontStyle">{{ item.name }}</p>
          </li>
        </ul>
        <div :class="getCss('lottery-lantern-optional-select-option-gift-checked')">
          <a :class="getCss('select-checked-package-text')" :style="selectRuleFontStyle">已经选择的道具：</a>
          <a :class="getCss('select-again')" @click="clearAllCheckBox" :style="selectRuleFontStyle">重置所有奖励</a>
          <ul :class="getCss('lottery-lantern-optional-select-option-gift-checked-ul')">
            <li :class="getCss('lottery-lantern-optional-select-option-gift-checked-li')"
                v-for="(item,key) in optionalRareList.filter( item=>item.checked === true )" :key="key">
              <div :class="getCss('lottery-lantern-optional-select-option-gift-checked-div')">
                <img :src="item.img">
              </div>
              <p :class="getCss('lottery-lantern-optional-select-option-gift-checked-p')" :style="routineFontStyle">
                {{ item.name }}
              </p>
            </li>
            <li :class="getCss('lottery-lantern-optional-select-option-gift-checked-li')"
                v-for="key of 20" :key="key + 'wxz'"
                v-show="key <= packageLimitNums - optionalRareList.filter( item=>item.checked === true ).length">
              <div :class="getCss('lottery-lantern-optional-select-option-gift-checked-div')">
                <img src="//game.gtimg.cn/images/tgclub/act/a20211209xinchun/unknow.png">
              </div>
            </li>
          </ul>
        </div>
        <p :class="getCss('lottery-confirm-checkbox-button')" :style="lotteryConfirmCheckboxButton"
           @click="confirmCheckbox"></p>
      </div>
    </div>
    <!-- 自选end -->
    <c-base-dialog v-model="isShow" :option="option"
                   @close="closeBtnClick"
                   @confirm="closeBtnClick"
                   @cancel="closeBtnClick" v-transfer-dom>
      <template slot="body">
        <div :class="getCss('reward-tips')">
          <div>恭喜你获得：{{ packageName }}</div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { baseComponents, componentBaseMixin } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
export default {
  name: 'CTgclubLotteryOptional',
  components: {
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-lottery-optional-',
      lotteryCzNum: 0,
      lotteryNum: 0,
      drawNum: 0,
      optionalRareList: [],
      carouselList: [],
      selectId: 0,
      lotteryLanternOptionalContentImg: 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/m/levels.png',
      getShowGiftNum: 0,
      packageLimitNums: 0,
      checkedBoxInfo: [],
      isShowOptionalPop: false,
      isLanternChecked: false,
      isShow: false,
      packageName: '',
      selectRuleText: '',
    };
  },
  computed: {
    option() {
      return Object.assign({}, this.dialogConfig, {
        fotter: true,
        close: true,
        header: '温馨提示',
        cancel: false,
        confirm: !!this.dialogConfig?.confirmStyle?.backgroundImage,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    optionalShowStyle() {
      return {
        ...this.styles.base,
        zIndex: 'unset'
      };
    },
    storyText() {
      return this?.configurationData?.storyText || '<点灯笼记录>';
    },
    lotteryCzText() {
      return this?.configurationData?.lotteryCzText || '当前充值金额';
    },
    lotteryNumText() {
      return this?.configurationData?.lotteryNumText || '花火数量';
    },
    // 抽奖数据展示背景
    lotteryOptionalInfo() {
      const lotteryImg = this?.configurationData?.lotteryImg || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/info.png';
      return {
        backgroundImage: `url(${lotteryImg})`,
        backgroundSize: 'cover',
      };
    },
    // 稀有道具展示背景
    lotteryOptionalRareBackground() {
      const lotteryOptionalRareImg = this?.configurationData?.lotteryOptionalRareImg
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/zbBj.png';
      return {
        backgroundImage: `url(${lotteryOptionalRareImg})`,
        backgroundSize: 'cover',
      };
    },
    // 自选按钮背景
    lotteryOptionalButton() {
      const lotteryOptionalButtonImg = this?.configurationData?.lotteryOptionalButtonImg
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/zxbt.png';
      return {
        backgroundImage: `url(${lotteryOptionalButtonImg})`,
        backgroundSize: 'cover',
      };
    },
    // 抽奖灯笼展示背景
    lotteryLanternUlBackground() {
      const lotteryLanternUlImg = this?.configurationData?.lotteryLanternUlImg
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/fj.png';
      return {
        backgroundImage: `url(${lotteryLanternUlImg})`,
        backgroundSize: 'cover',
      };
    },
    // 未点亮背景
    lotteryLanternBlack() {
      const lotteryLanternBlackImg = this?.configurationData?.lotteryLanternBlackImg
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/fjwdl.png';
      return lotteryLanternBlackImg;
    },
    // 已点亮展示背景
    lotteryLanternDrawBlack() {
      const lotteryLanternDrawBlackImg = this?.configurationData?.lotteryLanternDrawBlackImg
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/fidl.png';
      return lotteryLanternDrawBlackImg;
    },
    // 抽奖按钮背景
    lotteryLanternButton() {
      const lotteryLanternButtonImg = this?.configurationData?.lotteryLanternButtonImg
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/kfjbt.png';
      return {
        backgroundImage: `url(${lotteryLanternButtonImg})`,
        backgroundSize: 'cover',
      };
    },
    // 轮播展示背景
    lotteryLanternCarousel() {
      const lotteryLanternCarouselImg = this?.configurationData?.lotteryLanternCarouselImg
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/pm.png';
      return {
        backgroundImage: `url(${lotteryLanternCarouselImg})`,
        backgroundSize: 'cover',
      };
    },
    lotteryLanternOptionalContent() {
      const { lotteryLanternOptionalContentImg } = this;
      return {
        backgroundImage: `url(${lotteryLanternOptionalContentImg})`,
        backgroundSize: 'cover',
      };
    },
    // 关闭按钮背景
    lotteryLanternOptionalClose() {
      const lotteryLanternOptionalCloseImg = this?.configurationData?.lotteryLanternOptionalCloseImg
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/m/close1.png';
      return {
        backgroundImage: `url(${lotteryLanternOptionalCloseImg})`,
        backgroundSize: 'cover',
      };
    },
    lotteryLanternOptionalSelectLi() {
      // const widthNum = 90 / this.configurationData.selectUl.length;
      return {
        width: '1.42rem',
        marginTop: 0,
      };
    },
    lotteryLanternOptionalSelectLi1() {
      // const widthNum = 110 / this.configurationData.selectUl.length;
      return {
        width: '1.88rem',
        marginTop: 0,
      };
    },
    // 已自选展示背景
    selectOptionGiftChecked() {
      const selectOptionGiftCheckedImg = this?.configurationData?.selectOptionGiftCheckedImg
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/m/yxz.png';
      return selectOptionGiftCheckedImg;
    },
    // 未自选展示背景
    selectOptionGiftCheckbox() {
      const selectOptionGiftCheckboxImg = this?.configurationData?.selectOptionGiftCheckboxImg
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/m/wxz.png';
      return selectOptionGiftCheckboxImg;
    },
    // 提交自选按钮背景
    lotteryConfirmCheckboxButton() {
      const lotteryConfirmCheckboxButtonImg = this?.configurationData?.lotteryConfirmCheckboxButtonImg
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/m/confirmBtn.png';
      return {
        backgroundImage: `url(${lotteryConfirmCheckboxButtonImg})`,
        backgroundSize: 'cover',
      };
    },
    carouselLeftText() {
      return this?.configurationData?.carouselLeftText || '恭喜勇士';
    },
    routineFontStyle() {
      const fontStyle = this?.styles?.fontStyle || {};
      return {
        ...fontStyle,
      };
    },
    historyFontStyle() {
      const fontStyle = this?.styles?.historyFontStyle || {};
      return {
        ...fontStyle,
      };
    },
    carouselFontStyle() {
      const fontStyle = this?.styles?.carouselFontStyle || {};
      return {
        ...fontStyle,
      };
    },
    allowanceFontStyle() {
      const fontStyle = this?.styles?.allowanceFontStyle || {};
      return {
        ...fontStyle,
      };
    },
    selectRuleFontStyle() {
      const fontStyle = this?.styles?.selectRuleFontStyle || {};
      return {
        ...fontStyle,
      };
    },
  },
  async mounted() {
    console.log('configurationData=', this.configurationData);
    this.optionalRareList = this.configurationData.optional;
    const checkedBoxNumList = this.configurationData.checkedLimit.split(',');
    let levelLimitNums = 0;
    checkedBoxNumList.forEach((item) => {
      console.log('levelLimitValue', item);
      levelLimitNums += parseInt(item, 10);
    });
    console.log('levelLimitKeyA', levelLimitNums);
    this.packageLimitNums = levelLimitNums;
    this.$eventBus.$onLogined(await this.initialize);
  },
  methods: {
    async initialize() {
      if (this.$isInEditor && !this.isInPreview) return;
      this.selectClick(0);
      await this.doQueryOptionalRare();
      await this.doQueryHaveLotteryNums();
      await this.doQueryMoney();
      await this.doQueryLotteryNums();
      await this.queryCheckbox();
      await this.doQueryCarousel();
    },
    selectClick(id) {
      this.selectId = id;
      //  console.log(id);
      const selectAreaValue = ['optional_seldom', 'optional_rare', 'optional_senior', 'optional_ordinary'];
      this.reportFunc('optional_reward_select', {select_area: selectAreaValue[parseInt(id, 10)]});
      const lotteryLanternOptionalContentImgArr = this?.configurationData?.selectUl?.filter(
        item => parseInt(item.id, 10) === id);
      console.log('lotteryLanternOptionalContentImgArr', lotteryLanternOptionalContentImgArr);
      this.lotteryLanternOptionalContentImg = lotteryLanternOptionalContentImgArr[0].img
        || 'https://game.gtimg.cn/images/tgclub/act/a20211209xinchun/m/levels.png';
      this.selectRuleText = lotteryLanternOptionalContentImgArr[0].text || '';
      const getShowGiftArr = this?.optionalRareList?.filter(item => parseInt(item.first, 10) === this.selectId);
      this.getShowGiftNum = getShowGiftArr.length;
    },
    showLanternOptionalPop() {
      this.reportFunc('optional_reward_click');
      if (!this.isLogin) {
        this.alert('请先登录');
        return;
      }
      if (this.getTimeStamp() <= this.getTimeStamp(this.configurationData.startLotteryTime)) {
        this.$alert(this.configurationData.startLotteryMsg);
        return false;
      }
      // 检测角色绑定
      if (this.actInfo.extendConfig.forceRole && !this.isRoleReady && this.isRoleStatusValid) {
        this.alert('请先绑定角色');
        return;
      }
      this.isShowOptionalPop = true;
    },
    closeLanternOptionalPop() {
      this.isShowOptionalPop = false;
    },
    getCheckedInfo(packageId, isChecked) {
      if (!this.isLogin) {
        this.alert('请先登录');
        return;
      }
      if (this.isLanternChecked) {
        return false;
      }
      console.log(isChecked);
      const checkedBoxNumArr = this.optionalRareList.filter(item => item.checked === true
        && parseInt(item.first, 10) === this.selectId);
      const checkedBoxNumList = this.configurationData.checkedLimit.split(',');
      const levelLimit = window.parseInt(checkedBoxNumList[this.selectId]);
      const checkboxStatusArr = this.optionalRareList.find(
        optionalRare => parseInt(optionalRare.giftId, 10) === parseInt(packageId, 10));
      const checkboxIndex = this.optionalRareList.findIndex(
        optionalRareKey => parseInt(optionalRareKey.giftId, 10) === parseInt(packageId, 10));
      if (checkboxIndex < 0) {
        return false;
      }
      if (checkedBoxNumArr.length >= levelLimit) {
        if (isChecked) {
          this.$set(checkboxStatusArr, 0, checkboxStatusArr.checked = false);
          this.$set(checkboxStatusArr, checkboxIndex, checkboxStatusArr);
        }
        return false;
      }
      this.$set(checkboxStatusArr, 0, checkboxStatusArr.checked = !checkboxStatusArr.checked);
      this.$set(checkboxStatusArr, checkboxIndex, checkboxStatusArr);
    },
    clearAllCheckBox() {
      this.reportFunc('optional_reward_reset');
      if (!this.isLogin) {
        this.alert('请先登录');
        return;
      }
      if (this.isLanternChecked) {
        this.$toast('已确认自选礼，不可重置选择');
        return false;
      }
      const checkedBoxNumArr = this.optionalRareList.filter(item => item.checked === true);
      if (checkedBoxNumArr.length < 1) {
        return false;
      }
      this.optionalRareList.forEach((value, key) => {
        console.log(value);
        this.optionalRareList[key].checked = false;
      });
    },
    async confirmCheckbox() {
      this.reportFunc('optional_reward_submit');
      if (!this.isLogin) {
        this.alert('请先登录');
        return;
      }
      if (this.isLanternChecked) {
        this.$toast('已确认自选礼，请勿重复确认');
        return false;
      }
      // 检测角色绑定
      if (this.actInfo.extendConfig.forceRole && !this.isRoleReady && this.isRoleStatusValid) {
        this.alert('请先绑定角色');
        return;
      }
      const checkedBoxConfirmArr = this.optionalRareList.filter(item => item.checked === true);
      if (checkedBoxConfirmArr.length < 20) {
        this.$toast('自选礼尚未完成选择');
        return false;
      }
      const checkedBoxStrArr = [];
      checkedBoxConfirmArr.forEach((item) => {
        checkedBoxStrArr.push(item.giftId);
      });
      const checkedBoxStr = checkedBoxStrArr.join(',');
      console.log('checkedBoxStr', checkedBoxStr);
      const confirmData = { userChooseId: checkedBoxStr };
      const response = await this.flowRequest({
        flowId: this.configurationData.confirmOptionalFlowId,
        params: {
          role: this.roleInfo,
          data: JSON.stringify(confirmData),
        },
      });
      console.log(response);
      if (response.ret !== 0) {
        this.$alert(response.msg);
      } else {
        this.isLanternChecked = true;
        this.$alert('已确认自选礼包');
      }
    },
    async queryCheckbox() {
      if (this.configurationData.queryLanternCheckedFlowId === 0) {
        return  false;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.queryLanternCheckedFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log(response);
      if (response.ret === 0 && response.data.ret === 0) {
        const bindPackageListStr = response?.data?.allPackageIds || '';
        let bindPackageList = [];
        console.log('this.optionalRareList', this.optionalRareList);
        console.log('bindPackageListStr', bindPackageListStr);
        if (bindPackageListStr !== '') {
          bindPackageList = bindPackageListStr.split(',');
        }
        console.log('bindPackageList', bindPackageList);
        if (bindPackageList.length < 1) {
          return false;
        }
        this.isLanternChecked = true;
        bindPackageList.forEach((itemValue) => {
          console.log('itemValue', itemValue);
          const updateKey = this.optionalRareList.findIndex(
            item => parseInt(item.giftId, 10) === parseInt(itemValue, 10));
          if (updateKey > -1) {
            this.optionalRareList[updateKey].checked = true;
          }
        });
      }
    },
    async doLottery() {
      this.reportFunc('optional_reward_lottery');
      if (!this.isLogin) {
        this.alert('请先登录');
        return;
      }
      if (this.getTimeStamp() <= this.getTimeStamp(this.configurationData.startLotteryTime)) {
        this.$alert(this.configurationData.startLotteryMsg);
        return false;
      }
      if (!this.isLanternChecked) {
        this.$alert('请先确认自选礼');
        return false;
      }
      // 检测角色绑定
      if (this.actInfo.extendConfig.forceRole && !this.isRoleReady && this.isRoleStatusValid) {
        this.alert('请先绑定角色');
        return;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.lotteryFlowID,
        params: {
          role: this.roleInfo,
        },
      });
      console.log(response);
      if (response.ret === 0 && response.data.ret === 0) {
        this.packageName = response?.data?.msg.replace('恭喜您获得了礼包： ', '');
        this.isShow = true;
        await this.doQueryLotteryNums();
        await this.doQueryCarousel();
      } else {
        this.$alert(response.data.msg);
      }
    },
    closeBtnClick() {
      this.isShow = false;
    },
    async doQueryLotteryNums() {
      if (this.configurationData.queryLotteryNumsFlowId === 0) {
        return false;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.queryLotteryNumsFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log(response);
      if (response.ret === 0 && response.data.ret === 0) {
        this.drawNum = this.packageLimitNums - parseInt(response.data.limit, 10);
      }
    },
    async doQueryHaveLotteryNums() {
      if (this.configurationData.queryLotteryFlowId === 0) {
        return false;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.queryLotteryFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log(response);
      if (response.ret === 0 && response.data.ret === 0) {
        this.lotteryNum = parseInt(response.data.num, 10);
      }
    },
    async doQueryMoney() {
      if (this.configurationData.queryAmountFlowId === 0) {
        return false;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.queryAmountFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log(response);
      if (response.ret === 0) {
        this.lotteryCzNum = parseInt(response.data.ret, 10) / 100;
      }
    },
    async handleClaimRecord() {
      if (this.getTimeStamp() <= this.getTimeStamp(this.configurationData.startLotteryTime)) {
        this.$alert(this.configurationData.startLotteryMsg);
        return false;
      }
      const that = this;
      const pageSize = this.configurationData.popupPageSize || 6; // 每页记录数可配置,默认6
      await baseComponents.pacakgeClaimRecords.showPackageClaimRecords(that.gameCode, {
        hidePackageIds: (that.configurationData.hidePackageIds || '').split(','),
        params: {
          activity_id: that.actInfo.activity_id.toString(),
          business_id: that.actInfo.ast,
          resource_id: that.configurationData?.resource_id ? `${that.configurationData.resource_id}` : '',
          flow_version: that.actInfo.flow ? parseInt(that.actInfo.flow, 10) : 1,
          moduleId: that.configurationData?.moduleId ? `${that.configurationData.moduleId}` : '',
          category: that.configurationData?.category ? `${that.configurationData.category}` : '',
          iExcludePackageId: that.configurationData?.iExcludePackageId ? `${that.configurationData.iExcludePackageId}` : '',
          scene: that.configurationData?.scene ? `${that.configurationData.scene}` : 'ceiba_act',
        },
        pageSize,
        option: {
          header: false,
          footer: false,
          height: '3.6rem',
          width: '7.2rem',
          closeLocation: 'top-right',
          close: true,
          dialogStyle: Object.assign(
            {},
            {
              color: that.configurationData.recordsFontColor || '#fff',
              backgroundImage: `url(${that.configurationData.packageClaimBackgroundImage})`,
            },
          ),
        },
      });
    },
    async doQueryCarousel() {
      if (this.configurationData.queryCarouselFlowId === 0) {
        return false;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.queryCarouselFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log(response);
      if (response.ret === 0 && response.data.ret === 0) {
        this.carouselList = response.data.list;
      }
    },
    async doQueryOptionalRare() {
      if (this.configurationData.queryOptionalRareFlowId === 0) {
        return false;
      }
      const response = await this.flowRequest({
        flowId: this.configurationData.queryOptionalRareFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log('rareLeft', response);
      if (response.ret === 0 && response.data.ret === 0) {
        Object.keys(response.data.list).forEach((itemValue) => {
          const rareLeftIndex = this.optionalRareList.findIndex(
            item => parseInt(item.giftId, 10) === parseInt(itemValue, 10));
          if (rareLeftIndex > -1) {
            this.optionalRareList[rareLeftIndex].iLeft = response.data.list[itemValue].iLeft;
          }
        });
      }
    },
    reportFunc(key, obj) {
      console.log(this.actInfo.report_config);
      if (typeof  this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData: obj || {},
        };
        this.reportClickRaw(params);
        console.log(`reportFunc  to key  ${key} report  data =`, params);
      }
    },
    getTimeStamp(time) {
      if (time) {
        // ios 的时间格式需要更改一下
        // eslint-disable-next-line no-param-reassign
        time = time.replace(/-/g, '/');
        return parseInt(new Date(time).getTime() / 1000, 10);
      }
      return parseInt(new Date().getTime() / 1000, 10);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
